// extracted by mini-css-extract-plugin
export var activeUnderline = "header-module--activeUnderline--dc4ed";
export var header = "header-module--header--666b3";
export var headerPlaceholder = "header-module--headerPlaceholder--1d7ea";
export var headerPlaceholderScrolled = "header-module--headerPlaceholderScrolled--0255c";
export var headerScrolled = "header-module--headerScrolled--a4d08";
export var icon = "header-module--icon--24fbf";
export var inner = "header-module--inner--38c34";
export var isActive = "header-module--isActive--64a6d";
export var nav = "header-module--nav--7bc38";
export var socialLinksNav = "header-module--socialLinksNav--589e8";